import CrossWord from './CrossWord.js';
import HexWord from './HexWord.js';
import WordSearch from './WordSearch';
import Bingo from './Bingo';
import HexSearch from './HexSearch';

/* Copyright 2013-2018 Christopher Cady */
var listsDiv = document.getElementById("lists"),
	terms = document.getElementById("terms"),
	definitions = document.getElementById("definitions"),
	listCount = 0,
	activeList = 0,
	first = true;

(function populateLists() {
	addList(listCount);
	listCount++;
	while (listCount < 100 || localStorage.getItem("title" + listCount)) {
		if (localStorage.getItem("title" + listCount))
			addList(listCount);
		listCount++;
	}
	terms.innerHTML = localStorage.getItem("terms");
	definitions.innerHTML = localStorage.getItem("definitions");
})();

localStorage["size"] = 1;
localStorage["bingoSize"] = 4;
localStorage["bingoFree"] = "none";
localStorage["shape"] = "■";
localStorage["bank"] = "true";
localStorage["together"] = "false";

document.getElementById("wordSearch").onclick = function (e) {
	e.preventDefault();
	saveAndClear();
	new WordSearch(document.getElementById("worksheet"));
};

document.getElementById("hexSearch").onclick = function (e) {
	e.preventDefault();
	saveAndClear();
	new HexSearch(document.getElementById("worksheet"));
};

document.getElementById("crossWord").onclick = function (e) {
	e.preventDefault();
	saveAndClear();
	let crossWords = [];
	for (let i = 0; i < 100; i++) {
		crossWords.push(new CrossWord());
	}
	crossWords.sort((a, b) => { return b.intersections - a.intersections + a.size - b.size; });
	crossWords[0].create(document.getElementById("worksheet"));
};

document.getElementById("hexWord").onclick = function (e) {
	e.preventDefault();
	saveAndClear();
	let HexWords = [];
	for (let i = 0; i < 100; i++) {
		HexWords.push(new HexWord());
	}
	HexWords.sort((a, b) => { return b.intersections - a.intersections + a.size - b.size; });
	HexWords[0].create(document.getElementById("worksheet"));
};

document.getElementById("bingo").onclick = function (e) {
	e.preventDefault();
	saveAndClear();
	new Bingo(document.getElementById("worksheet"));
};

document.getElementById("addList").onclick = function () {
	listCount = 0;
	while (localStorage["title" + listCount]) {
		listCount++;
	}
	addList(listCount);
};

terms.addEventListener("input", function () {
	updateTerms();
});
definitions.addEventListener("input", function () {
	updateDefinitions();
});
document.getElementById("size1").onclick = function () {
	localStorage["size"] = "1";
};
document.getElementById("size16").onclick = function () {
	localStorage["size"] = "16";
};
document.getElementById("size24").onclick = function () {
	localStorage["size"] = "24";
};
document.getElementById("size32").onclick = function () {
	localStorage["size"] = "32";
};
document.getElementById("size48").onclick = function () {
	localStorage["size"] = "48";
};

document.getElementById("bankNo").onclick = function () {
	localStorage["bank"] = "false";
};
document.getElementById("bankYes").onclick = function () {
	localStorage["bank"] = "true";
};

document.getElementById("placeTogether").onclick = function () {
	localStorage["together"] = "true";
};
document.getElementById("placeRandomly").onclick = function () {
	localStorage["together"] = "false";
};

document.getElementById("bingoSize3").onclick = function () {
	localStorage["bingoSize"] = "3";
};
document.getElementById("bingoSize4").onclick = function () {
	localStorage["bingoSize"] = "4";
};
document.getElementById("bingoSize5").onclick = function () {
	localStorage["bingoSize"] = "5";
};

document.getElementById("bingoFreeNone").onclick = function () {
	localStorage["bingoFree"] = this.value;
};
document.getElementById("bingoFreeCenter").onclick = function () {
	localStorage["bingoFree"] = this.value;
};
document.getElementById("bingoFreeRandom").onclick = function () {
	localStorage["bingoFree"] = this.value;
};

document.getElementById("shape").addEventListener('change', function () {
	localStorage["shape"] = this.value;
});

function saveAndClear() {
	localStorage["title"] = document.getElementById("title" + activeList).value.replace(/^\n*/g, "").replace(/\n$/gm, "");
	localStorage["terms"] = terms.value.replace(/^\n*/g, "").replace(/\n$/gm, "");
	localStorage["definitions"] = definitions.value.replace(/^\n*/g, "").replace(/\n$/gm, "");
	document.getElementById("worksheet").innerHTML = "";
}

function addList(listCount) {
	var inputGroup = document.createElement("div");
	inputGroup.className = "input-group p-1";
	listsDiv.appendChild(inputGroup);
	var input = document.createElement("input");
	input.className = "form-control";
	input.id = "title" + listCount;
	input.type = "text";
	input.placeholder = "Title";
	input.value = localStorage.getItem(input.id);
	inputGroup.appendChild(input);
	input.addEventListener("input", function () {
		updateTitle(this);
	});
	input.innerHTML = localStorage.getItem("title" + listCount);
	var span = document.createElement("span");
	var buttonOpen = document.createElement("button");
	buttonOpen.className = "open btn btn-primary";
	buttonOpen.id = "open" + listCount;
	buttonOpen.innerHTML = "Open";
	if (first) {
		buttonOpen.disabled = true;
		activeList = listCount;
		openList(buttonOpen);
		first = false;
	}
	buttonOpen.addEventListener("click", function () {
		openList(this);
	});
	span.appendChild(buttonOpen);
	var buttonDelete = document.createElement("button");
	buttonDelete.className = "btn btn-danger";
	buttonDelete.id = "delete" + listCount;
	buttonDelete.innerHTML = "Delete";
	buttonDelete.addEventListener("click", function (e) {
		e.preventDefault();
		deleteList(buttonDelete);
	});
	span.appendChild(buttonDelete);
	inputGroup.appendChild(span);
}

function updateTitle(input) {
	var index = input.id.substring(5, input.id.length);
	localStorage[input.id] = input.value.replace(/^\n*/g, "").replace(/\n$/gm, "");
}

function updateTerms() {
	var string = "terms" + activeList;
	localStorage[string] = terms.value.replace(/^\n*/g, "").replace(/\n$/gm, "");
}

function updateDefinitions() {
	var string = "definitions" + activeList;
	localStorage[string] = definitions.value.replace(/^\n*/g, "").replace(/\n$/gm, "");
}

function deleteList(button) {
	var index = button.id.substring(6, button.id.length);
	button.parentNode.parentNode.parentNode.removeChild(button.parentNode.parentNode);
	if (index == activeList) {
		terms.value = "";
		definitions.value = "";
	}
	localStorage.removeItem("title" + index);
}

function openList(button) {
	var index = button.id.substring(4, button.id.length);
	activeList = index;
	var elements = document.getElementsByClassName("open btn btn-primary");
	for (var i = 0; i < elements.length; i++) {
		elements[i].disabled = false;
	}
	button.disabled = true;
	var string = "terms" + index;
	if ((localStorage.getItem(string)))
		terms.value = localStorage.getItem("terms" + index);
	else
		terms.value = "";
	var string = "definitions" + index;
	if ((localStorage.getItem(string)))
		definitions.value = localStorage.getItem("definitions" + index);
	else
		definitions.value = "";
}

// Fischer-Yates shuffle
export function shuffle(a) {
	var j,
		x,
		i;
	for (i = a.length; i; i--) {
		j = Math.floor(Math.random() * i);
		x = a[i - 1];
		a[i - 1] = a[j];
		a[j] = x;
	}
}
